'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardDescription, CardFooter, CardHeader } from '@/components/ui/card';
import Button from '@/components/ViverseButton';
import { Link } from '@/i18n/navigation';
import { Creator } from '@/services/cms';
type RecommendAvatarCardProps = {
  cardInfo: Creator;
};
export default function RecommendAvatarCard(t0) {
  const $ = _c(25);
  const {
    cardInfo
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== cardInfo.head_icon_url) {
    t1 = <AvatarImage src={cardInfo.head_icon_url} alt="Following Avatar" />;
    $[0] = cardInfo.head_icon_url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cardInfo.community_user_id) {
    t2 = <AvatarFallback>{cardInfo.community_user_id}</AvatarFallback>;
    $[2] = cardInfo.community_user_id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <Avatar className="1.5xl:size-24 m-auto size-[72px]">{t1}{t2}</Avatar>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cardInfo.display_name) {
    t4 = <h3 className="subheader-3 1.5xl:subheader-2 1.5xl:mt-4 mt-3">{cardInfo.display_name}</h3>;
    $[7] = cardInfo.display_name;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== cardInfo.community_user_id) {
    t5 = <CardDescription className="1.5xl:body-2 line-clamp-1">{cardInfo.community_user_id}</CardDescription>;
    $[9] = cardInfo.community_user_id;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <CardHeader className="text-center">{t3}{t4}{t5}</CardHeader>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `/profile/${cardInfo.community_user_id}`;
  let t8;
  if ($[15] !== t) {
    t8 = t("profile-page.following-section-recommend-follow-cta");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <Button variant="secondary" size="fit" className="min-w-[96px]">{t8}</Button>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <CardFooter className="justify-center"><Link href={t7}>{t9}</Link></CardFooter>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6) {
    t11 = <Card className="bg-card-blue-gradient 1.5xl:min-w-[200px] 1.5xl:gap-4 flex aspect-4/5 min-w-40 flex-col justify-center gap-3 rounded-[10px] border-0 px-4 py-6">{t6}{t10}</Card>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}